import { useLocation } from "react-router";

const useTituloPagina = () => {
  const location = useLocation();

  const renderSwitchTitlePage = () => {
    switch (location.pathname) {
      case "/Login":
        return "Login";
      case "/portal/Agenda":
        return "Agenda HHCC";
      case "/portal/Paciente":
        return "Ficha paciente HHCC";
      case "/portal/Nuevo Turno":
        return "Agendar turno HHCC";
      case "/privacidad":
        return "Política de Privacidad";
      default:
        return "Ubicacion no reconocida";
    }
  };

  const renamePage = () => {
    document.title = renderSwitchTitlePage() + " - Centro Ginecológico Allende Pinto";
  };

  renamePage();
};

export default useTituloPagina;
